<template>
  <v-chip color="grey lighten-3" close @click:close="toggleFilter">
    <strong>{{ question.properties | titleCase }}: {{ answer.label }}</strong>
  </v-chip>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  name: 'answer-filter-chips',
  props: ['answerId'],
  computed: {
    ...mapGetters(['CustomerPageFilters', 'Questions']),
    question: function() {
      return _.find(this.Questions, question => _.find(question.answers, ['id', this.answerId]));
    },
    answer: function() {
      return _.find(this.question.answers, ['id', this.answerId]);
    }
  },
  methods: {
    ...mapActions(['removeAnswerFilter', 'getCustomerPage']),
    getPage: _.debounce(function() {
      this.getCustomerPage(false)
        .then(() => {})
        .catch(error => {
          console.log(error);
        });
    }, 250),
    toggleFilter() {
      this.removeAnswerFilter({ questionId: this.question.id, answerId: this.answerId }).then(() => {
        this.getPage();
      });
    }
  },
  filters: {
    titleCase: function(string) {
      return _.words(string)
        .map(word => (word.length !== 3 ? _.capitalize(word) : word))
        .reduce((carry, word) => carry + ' ' + word, '');
    }
  }
};
</script>

<style lang="scss" scoped>
div.input-group {
  padding-top: 0;
}
::v-deep .input-group__details {
  display: none;
}
</style>
